import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { BUTTONS, HEADINGS, LABELS, PLACEHOLDERS } from "@/utils/constants/appConstants/commonConstants";
import AppButton from "@/components/buttons/AppButton";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface ContactModalProps {
    show?: boolean;
    onHide?: () => void;
    onContact: (subject: string, body: string) => void;
    loading?: boolean;
}

const ContactModal: React.FC<ContactModalProps> = (props) => {
    const [subject, setSubject] = useState<string>("");
    const [body, setBody] = useState<string>("");

    const handleSubmit = () => {
        if (subject.trim() && body.trim()) props.onContact(subject, body);
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{HEADINGS.CONTACT_USER}</DialogTitle>
                </DialogHeader>
                <div className="px-6 py-2 space-y-3">
                    <div>
                        <label className="text-sm font-medium text-foreground mb-1 block">{LABELS.SUBJECT}</label>
                        <Input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder={PLACEHOLDERS.EMAIL_SUBJECT} />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-foreground mb-1 block">{LABELS.MESSAGE}</label>
                        <Textarea rows={4} value={body} onChange={(e) => setBody(e.target.value)} placeholder={PLACEHOLDERS.EMAIL_BODY} className="min-h-[100px]" />
                    </div>
                </div>
                <DialogFooter>
                    <AppButton onClick={handleSubmit} className="btn-primary" btnText={BUTTONS.SEND} isLoading={props.loading} disabled={!subject.trim() || !body.trim() || props.loading} />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ContactModal;
